import React, {Component} from 'react'
import Template from '../interfaz/Template'
import AuthenticatedComponent from '../AuthenticatedComponent'
import {Layout, Form, Button, Modal, Row, Col, Icon, message} from 'antd'
import Checkbox from '../interfaz/Checkbox'
import TextArea from '../interfaz/TextArea'
import SourceViewer from '../interfaz/SourceViewer'
import RadioGroup, {Radio} from '../interfaz/Radio'
import Select, {Option} from '../interfaz/Select'
import Calendario from '../interfaz/Calendario'
import Tiempo from '../interfaz/Tiempo'
import Cubrimiento from '../interfaz/Cubrimiento'
import InputText from '../interfaz/InputText'
import {connect} from 'react-redux'
import axios from 'axios'
import {irAtras, toggleMostrar, establecerIniciales, compararValores, verifiedToken} from '../../utils/funciones'
import {implantarAspirante} from '../../redux/user/user-actions'
import {emitirOperacion, borrarOperacion} from '../../redux/actions/accionesOperacion'
import moment from 'moment'
import * as etiquetas from '../../ApplicationResources'
import { Link } from "react-router-dom"
import errorImgModal from '../../img/error_icon.svg';
import infow_iconModal from '../../img/infow_icon.png';
import { createStructuredSelector } from 'reselect'
import { selectProceso } from '../../redux/menu/menu-selectors'
import { selectAspirante, selectCurrentUser } from '../../redux/user/user-selectors'
import { selectOperaciones } from '../../redux/selectors/selectorOperaciones'

let msjError = "";
let msjInfoW = "";

const {Header, Sider, Footer, Content} = Layout;
var _compararValores;

const rolesCaptura = ['SCE.ADMIN.OC', 'SCE.CAPTURA.JD', 'SCE.CAPTURA.JL', 'SCE.CAPTURA.OC', 'SCE.CAPTURA_CONSEJERO.JL', 'SCE.CAPTURA_VE.JD', 'SCE.CAPTURA_VE.JL', 'SCE.CAPTURA_VCEYEC.JD', 'SCE.CAPTURA_VCEYEC.JL', 'SCE.CAPTURA_CONSEJERO.JD', 'SCE.CONSULTA_EXT.OPL.JL',"SCE.CONSULTA.OC", "SCE.CONSULTA.JL", "SCE.CONSULTA.JD"];
//const rolesConsulta = ['SCE.CAU.OC', 'SCE.CONSULTA.JD', 'SCE.CONSULTA.JL', 'SCE.CONSULTA.OC', 'SCE.CONSULTA_EXT.OPL.JD', 'SCE.CONSULTA_EXT.OPL.JL', 'SCE.CONSULTA_EXT.OPL.JM', 'SCE.CONSULTA_EXT.REST.JD', 'SCE.CONSULTA_EXT.REST.JL', 'SCE.CONSULTA_EXT.REST.OC', 'SCE.CONSULTA_RESTRINGIDA.JD', 'SCE.CONSULTA_RESTRINGIDA.JL', 'SCE.CONSULTA_RESTRINGIDA.OC'];

class ValidacionDocumentos extends Component {
    state = {
        cuadroFoco: undefined,
        tab: 0,
        cargado: false,
        sedesCargadas: false,
        mostrarCarta: false,
        widthModal: 520,
        mostrarCuadroExamen: false,
        validacion: [],
        todosValidos: false,
        cargando: false,
        declina: false,
        activaGuardado: false,
        mostrarConfirmacion: false,
        //mostrarNoHaySede: false,
        mostrarPlaticaInducion: false,
        mostrarDeshacerDeclinacion : false,
        fechaHoraCargadas: false,
        sede: "", idSede: 0,
        numConv: 0,
        msjError : "",
        abrirModalError : false,
        abrirModalInfoW: false,
        primeraConv: false,
        listaFechas: [],
        listaHoras: [],
        idSedeSeleccionada: 0,
        idProgramacionSede: undefined,
        horaSeleccionada: undefined,
        encuentraOtroCorte: false,
        mostrarMensajeOtroCorte: false
    }

    irAtras = irAtras.bind(this);

    constructor(props) {
        super(props);

        this.recursos = {};
        this.controlls = [];
        this.establecerIniciales = establecerIniciales.bind(this);
        this.confirmacion = '¿Estás seguro?';
        _compararValores = compararValores.bind(this, this.callbackCambio, this.callbackRegreso);
        
    }

    cerrarErrorModal(){
      this.setState({abrirModalError:false});
    }
    cerrarInfoWModal(){
        this.setState({abrirModalInfoW:false});
      }

    UNSAFE_componentWillReceiveProps = (nextProps) => {
        nextProps.form.haValidado = this.props.form.haValidado;
    }

    listo = async() => {
        const datosAspirante = this.props.datosAspirante;
        const datosUsuario = this.props.datosUsuario;

        if (!datosAspirante) {
            this.props.history.push('/bandeja');
            return;
        }

        const jwt = localStorage.getItem('jwt-token');

        const url = process.env.REACT_APP_API_URL + '/ws_reclutaseycae_central/ws/obtener_archivo';
        const viewers = [];
        viewers[0] = [];
        viewers[1] = [];

        // Si el aspirante tiene documentación
        if(datosAspirante.tieneDocumentacion === 'S') {
            await axios.post(process.env.REACT_APP_API_URL + '/ws_reclutaseycae_central/ws/obtener_observaciones_archivos', {
                idProcesoElectoral: datosAspirante.idProcesoElectoral,
                idDetalleProceso: datosAspirante.idDetalleProceso,
                idParticipacion: datosAspirante.idParticipacion,
                idAspirante: datosAspirante.idAspirante,
            },
            {
                responseType: 'application/json',
                headers: {Authorization: jwt }
                
            }).then(res => {
                const archivosObservaciones = res.data.archivosObservaciones;
                const arregloDocs = archivosObservaciones.listaObservaciones;
                const acudirJDE = archivosObservaciones.acudirJDE ? (archivosObservaciones.estatusRegistro === 4 || archivosObservaciones.estatusRegistro === 5) ? 'false' : 'true' : ((archivosObservaciones.estatusRegistro === 4 || archivosObservaciones.estatusRegistro === 5) ? 'false' : undefined);
                this.listaObservaciones = [];
    
                this.props.form.setFields({radioDecision: {value: acudirJDE}});
                this.setState({declina: acudirJDE === 'false'})
    
                arregloDocs.forEach(valor => {
                    const renglon = {};
                    renglon.idTipoDocumento = valor.idTipoDocumento;
                    renglon.titulo = valor.nombreDocumento;
                    renglon.src = valor.nombreArchivo;
                    renglon.observacion = valor.observaciones;
                    renglon.archivoValido = valor.archivoValido;
                    const nombre = valor.nombreDocumento.replace(/ (de|para)/g, ' ').toLowerCase();
                    renglon.nombre = nombre.split(' ').map((val, index) => {
                        return index > 0 ? val.charAt(0).toUpperCase() + val.substring(1) : val;
                    }).join('');
    
                    const nombreArchivoMin = valor.nombreArchivo.toLowerCase();
    
                    if (nombreArchivoMin.endsWith('.jpeg') || nombreArchivoMin.endsWith('.jpg'))
                        renglon.type = 'image/jpeg'
                    else if (nombreArchivoMin.endsWith('.png'))
                        renglon.type = 'image/png'
                    else
                        renglon.type = 'application/pdf'
    
                    renglon.url = url;
    
                    viewers[valor.obligatorio === 'S' ? 0 : 1].push(renglon);
                    this.listaObservaciones[renglon.nombre] = valor;
                });
    
                function visible(indice) {
                    return this.state.tab === indice;
                }
    
                const cubrir = this.props.operaciones.accion !== 'captura' || datosAspirante.bAcudirJDE === 1 ||
                               datosAspirante.estatusRegistro === 4 || datosAspirante.estatusRegistro === 5 || 
                               !rolesCaptura.some(rol => (datosUsuario.rolUsuario === rol));
    
                this.renderViews = () => {
                    const _viewers = {viewers: [], controlls: []};
    
                    for (var i = 0; i < 2; i++) {
                        viewers[i].forEach(data => {
                            _viewers.viewers.push(<SourceViewer key={data.nombre + 'Sv'}
                                                        nombre={data.nombre}
                                                        urlDoc={url}
                                                        titulo={data.titulo}
                                                        type={data.type}
                                                        data={{idProcesoElectoral: datosAspirante.idProcesoElectoral,
                                                            idDetalleProceso: datosAspirante.idDetalleProceso,
                                                            idParticipacion: datosAspirante.idParticipacion,
                                                            idConvocatoria: datosAspirante.idConvocatoria,
                                                            folio: datosAspirante.folio,
                                                            claveElectorFuar: datosAspirante.claveElectorFuar,
                                                            src: data.src}}
                                                            cuadroFoco={this.state.cuadroFoco}
                                                        recursos={this.recursos}
                                                        visible={visible.bind(this, i)}/>);
                            _viewers.controlls.push(<CuadroValidacion id={data.idTipoDocumento}
                                                            key={data.nombre + 'Ctrl'}
                                                            form={this.props.form}
                                                            nombre={data.nombre}
                                                            titulo={data.titulo}
                                                            cambioFoco={this.cambiarFoco}
                                                            scrollVisor={this.scrollVisor}
                                                            declina={this.state.declina}
                                                            visible={visible.bind(this, i)}
                                                            archivoValido={data.archivoValido}
                                                            observacion={data.observacion}
                                                            cubrir={cubrir}
                                                            cambiarValidacion={this.cambiarValidacion}
                                                            tab={this.state.tab}/>);
                        });
                    }
    
                    return _viewers;
                }
    
                this.setState({cargado: true});
            }).catch(error => {
              console.error("Error al obtenr archivos y observaciones "+
                  "listo()",error);
              if (error.response){
                  if (error.response.status === 409){
                      msjError = error.response.data.message;
                  } else if (error.response.data && error.response.data.causa
                      && error.response.data.causa.includes("Error de validación")){
                      msjError = error.response.data.message;
                  } else {
                      msjError = etiquetas.gral_error_cau;
                  }
              } else {
                  msjError = etiquetas.gral_error_cau;
              }
              this.setState({
                msjError : msjError,
                abrirModalError : true
              });
    
            });
        }

        
        const json = {
            "idProcesoElectoral" : this.props.datosAspirante.idProcesoElectoral,
            "idDetalleProceso" : this.props.datosAspirante.idDetalleProceso,
            "idEstado" : this.props.datosAspirante.idEstado,
            "seccion" : this.props.datosAspirante.seccionDom,
            "idDistrito" : this.props.datosAspirante.idDistrito,
            "idConvocatoria" : this.props.datosAspirante.idConvocatoria
          }

          let hd = { 'Accept': 'application/json'
                    ,'Content-Type': 'application/json'};
    
          hd = verifiedToken(hd);  
          await axios.post(process.env.REACT_APP_API_URL + '/ws_reclutaseycae_central/ws/consultar_corte'
              , json
              , {
                  headers: hd
              }
          ).then( response => {
            if(response.data !== undefined){
                this.setState({encuentraOtroCorte: response.data.data})
            }
          })
          
          

        await axios.post(process.env.REACT_APP_API_URL + '/ws_reclutaseycae_central/ws/obtenerNoConvocatoria', {
            idDetalleProceso: datosAspirante.idDetalleProceso,
            idParticipacion: datosAspirante.idParticipacion,
            idConvocatoria: datosAspirante.idConvocatoria
        },{
            responseType: 'application/json',
            headers : {Authorization: jwt}
        }).then(res => {
            this.setState({numConv: res.data.numeroConvocatoria});
            var postData = {};
            if(datosAspirante.otroCorte !== 1 && !this.state.encuentraOtroCorte){
                /*postData = {idDetalleProceso: datosAspirante.idDetalleProceso,
                            idParticipacion: datosAspirante.idParticipacion}*/
                            postData = {idDetalleProceso: datosAspirante.idDetalleProceso,
                                idParticipacion: datosAspirante.idParticipacion,
                                seccion: datosAspirante.seccionDom}
                                axios.post(process.env.REACT_APP_API_URL + '/ws_reclutaseycae_central/ws/obtener_sedes', postData,
                                    {
                                        responseType: 'application/json',
                                        headers : {Authorization: jwt}
                                    }).then(res => {
                                        this.listaSedes = res.data.entity;
                                        this.setState({sedesCargadas: true});
                                        
                                    });
            }else{
                this.setState({sedesCargadas: true});
            }
            
        });
        
    }

    consultarSecciones = async  () =>{
        const jwt = localStorage.getItem('jwt-token');
        const datosAspirante = this.props.datosAspirante;
        const datosUsuario = this.props.datosUsuario;
        await axios.post(process.env.REACT_APP_API_URL + '/ws_reclutaseycae_central/ws/obtenerNoConvocatoria', {
            idDetalleProceso: datosAspirante.idDetalleProceso,
            idParticipacion: datosAspirante.idParticipacion,
            idConvocatoria: datosAspirante.idConvocatoria
        },{
            responseType: 'application/json',
            headers : {Authorization: jwt}
        }).then(res => {
            this.setState({numConv: res.data.numeroConvocatoria});
            var postData = {};
            if(datosAspirante.otroCorte !== 1 && !this.state.encuentraOtroCorte){
                /*postData = {idDetalleProceso: datosAspirante.idDetalleProceso,
                            idParticipacion: datosAspirante.idParticipacion}*/
                            postData = {idDetalleProceso: datosAspirante.idDetalleProceso,
                                idParticipacion: datosAspirante.idParticipacion,
                                seccion: datosAspirante.seccionDom}
                                axios.post(process.env.REACT_APP_API_URL + '/ws_reclutaseycae_central/ws/obtener_sedes', postData,
                                    {
                                        responseType: 'application/json',
                                        headers : {Authorization: jwt}
                                    }).then(res => {
                                        this.listaSedes = res.data.entity;
                                        this.setState({sedesCargadas: true});
                                        if(this.listaSedes !== null && this.listaSedes.length === 1){
                                            const datosSede = `${this.listaSedes[0].lugar} | ${this.listaSedes[0].domicilioSede}, Col. ${this.listaSedes[0].colonia}, C.P. ${this.listaSedes[0].cp}`
                                            this.setState({ sede : datosSede, idSede: this.listaSedes[0].idSede, sinSede: false });
                                        }
                                    });
            }else{
                this.setState({sedesCargadas: true});
            }
            
        });
  }

    cambiarFoco = (nuevoCuadro, cb) => {
        this.setState(state => {
            if (nuevoCuadro === state.cuadroFoco)
                return state;

            cb();
            return {cuadroFoco: nuevoCuadro};
        });
    }

    scrollVisor = (idRecurso) => {
        if (this.recursos[idRecurso] === undefined)
            return;

        const offset = this.recursos[idRecurso].offsetTop;
        const divVisor = document.getElementsByClassName('visor_validar')[0];

        divVisor.scrollTop = offset - 15;
    }

    cambiarTab(newTab) {
        this.setState({tab : newTab, cuadroFoco: undefined});
    }

    toggleMostrar = toggleMostrar.bind(this);

    modificaModal = () => {
        const canvas = document.getElementById('cartaDeclararoriaCanvas');
        const totalWidth = canvas.clientWidth + 48;

        this.setState({widthModal: totalWidth >= 520 ? totalWidth : 520});
    }

    manejarRadiosJDE = (rad) => {
        const val = this.props.form.getFieldValue('radioDecision');

        if (this.props.datosAspirante.bAcudirJDE !== 1 &&
            val === rad)

            this.props.form.setFields({radioDecision: {}});

        this.confirmacion = rad === 'permite' ? '¿Estás seguro de que deseas autorizar?' : '¿Estás seguro?';

        this.setState({declina: val !== rad && rad === 'false'});
    }

    cancelarRevision = () => {
        this.props.borrarOperacion();
        this.props.implantarAspirante(null);
        this.props.history.push('/bandeja');
        //this.irAtras('/bandeja');
    };

    validarRevision = () => {
        var todosValidos = true, validados = true;
        var tab = this.state.tab;
        const fieldsErrors = {};
        const val = this.props.form.getFieldValue('radioDecision');
        this.state.validacion.forEach(valor => {
            if (valor.archivoValido === undefined || valor.archivoValido === null) {
                todosValidos = false;

                if(valor.observaciones === undefined && (val === 'true' || val === 'false')) {
                    valor.archivoValido = 'N';
                    valor.observaciones = 'Acudir a JDE';
                }else if(valor.observaciones === undefined && (val === undefined || val === null)) {
                    validados=false;
                    const error = new Error('Se debe validar o rechazar cada documento para poder guardar');
                    fieldsErrors[valor.nombre + 'Msj'] = {errors: [error, new Error('')]};
                }
                tab = this.listaObservaciones[valor.nombre].obligatorio === 'S' ? 0 : 1;
            }
            else if (valor.archivoValido === 'N')
                validados = false;
        });

        

        this.props.form.validateFieldsAndScroll((errors) => {
            const keys = errors !== null ? Object.keys(errors) : [];
            this.props.form.haValidado = true;

            const errorGuardar = keys.some(valor => {
                return ((valor !== 'sede' && valor !== 'fechaExamen' && valor !== 'horaExamen') &&
                        (valor !== 'sede' && valor !== 'fechaExamenId' && valor !== 'horaExamen'));
            });
            
            if (todosValidos && !errorGuardar) {
                if (validados){
                    this.setState({mostrarConfirmacion:false});
                    
                    if(!this.props.datosAspirante.idSedeProgramada) {
                        if(this.props.datosAspirante.bPlatica !== null || this.props.datosAspirante.idPlatica !== null){
                           if(this.listaSedes !== undefined){
                                if(this.listaSedes.length === 1){
                                    this.obtenerFechasSedes(this.listaSedes[0].id.idSede)
                                }
                            }      
                            if(this.props.datosAspirante.otroCorte === 1 || this.state.encuentraOtroCorte){
                                msjInfoW = 'Para asignar una sede de examen, actualiza la sección del aspirante, ya que no existe en el corte geográfico actual.';
                                this.setState({ msjInfoW : msjInfoW,
                                                abrirModalInfoW : true
                                            });
                            }
                            this.setState({mostrarCuadroExamen: true});
                            this.asignaSede(this.listaSedes);
                        }else{
                            this.setState({mostrarPlaticaInducion: true});
                        }
                    } else {
                        if(this.state.encuentraOtroCorte){
                            this.setState({mostrarMensajeOtroCorte:true})
                        }
                        this.setState({mostrarDeshacerDeclinacion: true});
                    }
                }else {
                    
                    this.setState({mostrarConfirmacion:false});
                    this.guardarRevision(false); //true false
                }
            }
            else if (!todosValidos){
                if(validados === false){
                    
                    this.props.form.setFields(fieldsErrors);
                    this.setState({mostrarConfirmacion: false});
                }else{
                    
                    this.setState({mostrarConfirmacion:false});
                    this.guardarRevision(false);
                    //this.setState({mostrarCuadroExamen: true});
                }
            }else{
                this.setState({mostrarConfirmacion: false});
            }

            if (errorGuardar) {
                const campo = keys[0];
                const key = Object.keys(this.listaObservaciones).filter(valor => {return campo.startsWith(valor)})[0];
                const obs = this.listaObservaciones[key];
                tab = obs.obligatorio === 'S' ? 0 : 1;
            }

            const nuevoCuadroFoco = this.state.tab !== tab ? undefined : this.state.cuadroFoco;

            this.setState({
                tab,
                cuadroFoco: nuevoCuadroFoco,
            }, () => {
                if (errorGuardar)
                    this.props.form.validateFieldsAndScroll();
            });
        });

        //this.asignaSede(this.listaSedes);
    }

    asignaSede(sede){
        if(sede !== null && sede.length === 1){
            const datosSede = `${sede[0].lugar} | ${sede[0].domicilioSede}, Col. ${sede[0].colonia}, C.P. ${sede[0].cp}`
            this.setState({ sede : datosSede, idSede: sede.idSede });

            axios.post(process.env.REACT_APP_API_URL + '/ws_reclutaseycae_central/ws/algoritmoSelectivo', {
                idProcesoElectoral : this.props.datosAspirante.idProcesoElectoral,
                idDetalleProceso : this.props.datosAspirante.idDetalleProceso
            }, {
                responseType: 'application/json',
                headers : {Authorization: localStorage.getItem('jwt-token')}
            }).then(res => {
                this.listaFechaHora = [];
                this.listaFechaHora.push(res.data.cfechas);
                this.setState({ fechaHoraCargadas: true });
                this.listaFechaHora.forEach(valor => {
                    // REQUERIMIENTO: Para la primera convocatoria se solicita mostrar automáticamente la fecha y hora válidas (en C_FECHAS).
                    if (this.state.numConv === 1 && (valor !== null && valor.fecha !== null) ) {
                        this.setState({ primeraConv: true });
                        this.props.form.setFieldsValue({
                            //fechaExamen: moment(parseInt(valor.fecha)),
                            horaExamen: moment(parseInt(valor.fecha))
                        });
                    }     
                });
            });
        }else if(sede === null || sede.length === 0){
            msjInfoW = 'Aún no se registran sedes de examen para la sección donde participará el aspirante.';
            this.setState({ msjInfoW : msjInfoW,
                            abrirModalInfoW : true
                        });
        }
    }

    obtenerDatosSede = (fechaExamenId) =>{
        var fechaHoraId = {};
        this.listaFechaHora.forEach(valor => {
            if(valor.id.idFecha === fechaExamenId){
                fechaHoraId.fecha = moment(valor.fecha);
                fechaHoraId.hora = moment(valor.fecha).format("HH:mm");
            }
        });
        return fechaHoraId;
    }

    guardarRevision = (validados) => {
        const { proceso } = this.props;
        const idCorte = proceso ? proceso.corte : 0;
        this.props.form.validateFieldsAndScroll((errors, values) => {
            const datosAspirante = this.props.datosAspirante;
            const datosUsuario = this.props.datosUsuario;
            const listaObservaciones = [];
            const nombreProceso = this.props.descripcionDetalleLarga;

            if (this.props.operaciones.accion !== 'asignaSede')
                this.state.validacion.map(valor => {
                    listaObservaciones.push(valor);
                });

            if (!datosUsuario.nombreProceso)                
                datosUsuario.nombreProceso = proceso.descripcionDetalleLarga;

            const keys = errors !== null ? Object.keys(errors) : [];
            var error = keys.length !== 0;

            this.setState({cargando: true});

            const guarda = {
                idProcesoElectoral: datosAspirante.idProcesoElectoral,
                idDetalleProceso: datosAspirante.idDetalleProceso,
                idParticipacion: datosAspirante.idParticipacion,
                idAspirante: datosAspirante.idAspirante,
                correo: datosAspirante.correo,
                folioAcceso: datosAspirante.folioAcceso,
                idSedeReclutamiento: datosAspirante.idSedeReclutamiento,
                acudirJDE: !this.state.todosValidos && values.radioDecision === 'true',
                declinarSolicitud: !this.state.todosValidos && values.radioDecision === 'false',
                permitirRegistro: values.radioDecision === 'permite',
                usuario: datosUsuario.username,
                listaObservaciones,
                platica: datosAspirante.bPlatica,
                idConvocatoria: datosAspirante.idConvocatoria,
                folio: datosAspirante.folio,
                claveElectorFuar: datosAspirante.claveElectorFuar,
                nombreProceso: datosUsuario.nombreProceso,
                idCorte: idCorte,
                idProgramacionSede: this.state.idProgramacionSede
            };
            
            const platicaInduccion = datosAspirante.bPlatica !== null || datosAspirante.idPlatica !== null ? true : false;
            
            if (!error && !values.sinCede  && this.listaSedes !== null && platicaInduccion && values.radioDecision !== 'permite') {
                if(values.fechaExamen !== undefined  ){
                    this.listaSedes.length === 1 ? guarda.idSedeProgramada = this.listaSedes[0].id.idSede :
                    guarda.idSedeProgramada = values.sede;
                    guarda.fechaProgramada = this.state.listaFechas[values.fechaExamen].fechaEvento;
                    guarda.horaProgramada = this.state.horaSeleccionada;
                    guarda.sede = this.state.sede; 
                    //guarda.fechaProgramadaFormato = values.fechaExamen.format('DD/MM/YYYY');
                    guarda.idProgramacionSede = this.state.idProgramacionSede
                    
                    // Se filtra la información de la sede que seleccionó el usuario
                    const sede = this.listaSedes.filter(
                        
                        (item) => item.id && parseInt(item.id.idSede) === parseInt(this.listaSedes.length === 1 ? this.listaSedes[0].id.idSede : values.sede)
                    )
                    const datosSede = sede && sede.length > 0 ? `${sede[0].lugar} | ${sede[0].domicilioSede}, Col. ${sede[0].colonia}, C.P. ${sede[0].cp}` : ""
                    // Se actualiza la información de la sede seleccionada
                    guarda.sede = datosSede;
                    
                }
                
            }

            if(datosAspirante.estatusRegistro === 4 || datosAspirante.estatusRegistro === 5){
                if(datosAspirante.idSedeProgramada !== null && datosAspirante.idSedeProgramada !== undefined){
                guarda.idSedeProgramada = datosAspirante.idSedeProgramada
                guarda.fechaProgramada = datosAspirante.fechaProgramada.split(' ')[0];
                guarda.horaProgramada = datosAspirante.horaProgramada
                guarda.sede = this.state.sede; 
                //guarda.fechaProgramadaFormato = values.fechaExamen.format('DD/MM/YYYY');
                guarda.idProgramacionSede = datosAspirante.idProgramacionSede
                
                // Se filtra la información de la sede que seleccionó el usuario
                if(this.listaSedes !== undefined){
                    const sede = this.listaSedes.filter(
                        
                        (item) => item.id && parseInt(item.id.idSede) === parseInt(this.listaSedes.length === 1 ? this.listaSedes[0].id.idSede : datosAspirante.idSedeProgramada)
                    )
                    
                    const datosSede = sede && sede.length > 0 ? `${sede[0].lugar} | ${sede[0].domicilioSede}, Col. ${sede[0].colonia}, C.P. ${sede[0].cp}` : ""
                    // Se actualiza la información de la sede seleccionada
                    guarda.sede = datosSede;
                }
                }
            }

            if(values.sinCede){
                guarda.idSedeProgramada = undefined
            }

            if(guarda.sede !== undefined){
                if(guarda.sede === ""){
                    guarda.sede = undefined
                }
            }

            if (!error || !validados) {
                const jwt = localStorage.getItem('jwt-token');
                axios.post(process.env.REACT_APP_API_URL + '/ws_reclutaseycae_central/ws/guardar_observaciones', guarda,
                {
                    responseType: 'application/json',
                    headers : {Authorization: jwt}
                }).then(res => {
                    if (res.data.code === 200) {
                        this.props.borrarOperacion();

                        if (values.radioDecision !== 'permite') {
                            const datosAspiranteMod = Object.assign({}, datosAspirante);
                            datosAspiranteMod.bAcudirJDE = 0;

                            this.props.implantarAspirante(datosAspiranteMod);
                        }
                        
                        this.props.emitirOperacion({
                            radioDecision: values.radioDecision,
                            asignaSede: true,
                            infoSede: guarda,
                            irA: '/bandeja',
                            deshacerDeclinacion: datosAspirante.estatusRegistro === 4 || datosAspirante.estatusRegistro === 5 ? true : false
                        });

                        this.props.history.push('/operacion_exitosa');
                    }

                    this.setState({cargando: false});
                }).catch(err => {
                    this.setState({cargando: false,
                                   mostrarCuadroExamen: false});

                    if (err.response && err.response.data === 'error_token')
                        this.props.history.push('/loginSEyCAE');
                });
            }
            else
                this.setState({cargando: false});
        });

    }

    cambiarValidacion = ({nombre, id, validado, observacion}) => {
        this.setState(state => {
            const obj = [];
            Object.assign(obj, state.validacion);
            obj[id] = {};
            obj[id].nombre = nombre;
            obj[id].idTipoDocumento = id;
            obj[id].archivoValido = validado;
            obj[id].observaciones = validado === 'N' ? observacion : undefined;

            if (validado)
                this.props.form.setFields({[nombre + 'Msj'] : {errors: []}});

            const todosValidos = !obj.some(valor => {
                return valor.archivoValido !== 'S';
            });

            return {validacion: obj, todosValidos};
        });
    }

    callbackCambio = () => {
        this.setState({activaGuardado: true});
    }

    callbackRegreso = () => {
        this.setState({activaGuardado: false});
    }

    confirmar = () => {
        this.setState({mostrarConfirmacion: true});
    }
    cancelarConfirmacion = () => {
        this.setState({mostrarConfirmacion: false,
                    listaFechas: [],
                    listaHoras: [],
                    idProgramacionSede: undefined,
                    horaSeleccionada: undefined
        });
    }
    cambioAsignarSede = (valor) => {
        this.setState({
            sede:undefined,
            fechaExamen: undefined,
            horaExamen:undefined
        })
        this.props.form.setFieldsValue({'sede': undefined});
        this.props.form.setFieldsValue({'fechaExamen': undefined});
        this.props.form.setFieldsValue({'horaExamen': undefined});
        if(valor === false){
            this.consultarSecciones()
        }
    }

    cancelarDeshacerDeclinacion = () => {
        this.setState({mostrarDeshacerDeclinacion : false, mostrarMensajeOtroCorte:false});
    }

    obtenerFechasSedes = async(sede) => {
        this.props.form.setFields({fechaExamen: undefined});
        this.props.form.setFields({horaExamen: undefined});
            this.setState({
                listaFechas: [],
                listaHoras:[],
                idProgramacionSede: undefined
            })
            const jwt = localStorage.getItem('jwt-token');
            await axios.post(process.env.REACT_APP_API_URL + '/ws_reclutaseycae_central/ws/obtener_fechas_sedes', {
                idDetalleProceso: this.props.datosAspirante.idDetalleProceso,
                idParticipacion: this.props.datosAspirante.idParticipacion, 
                idSede: sede,
                idConvocatoria: this.props.datosAspirante.idConvocatoria,
                idProcesoElectoral: this.props.datosAspirante.idProcesoElectoral
            },{
                responseType: 'application/json',
                headers : {Authorization: jwt}
            }).then(res => {
                if(res.data.entity.length > 0){
                    this.state.listaFechas = res.data.entity
                    this.setState({
                        listaFechas: res.data.entity
                    })
                }else{
                    msjInfoW = 'Aún no se registran fechas para esta sede.';
                    this.setState({ msjInfoW : msjInfoW,
                            abrirModalInfoW : true
                        });
                }
            });
            this.setState({
                idSedeSeleccionada: sede
            })
        
    }

    obtenerHorasSedes = async(hora) => {
        this.props.form.setFields({horaExamen: undefined});
        this.setState({
            listaHoras:[],
            idProgramacionSede: undefined
        })
        const jwt = localStorage.getItem('jwt-token');
        await axios.post(process.env.REACT_APP_API_URL + '/ws_reclutaseycae_central/ws/obtener_horas_sedes', {
            idDetalleProceso: this.props.datosAspirante.idDetalleProceso,
            idParticipacion: this.props.datosAspirante.idParticipacion, 
            idSede: this.state.idSedeSeleccionada,
            idConvocatoria: this.props.datosAspirante.idConvocatoria,
            idProcesoElectoral: this.props.datosAspirante.idProcesoElectoral,
            horaSede: this.state.listaFechas[hora].fechaEvento
        },{
            responseType: 'application/json',
            headers : {Authorization: jwt}
        }).then(res => {
            if(res.data.entity.length > 0){
                this.state.listaHoras = res.data.entity
                    this.setState({
                        listaHoras: res.data.entity
                    })
            }else{
                msjInfoW = 'Aún no se registra el horario para esta sede.';
                this.setState({ msjInfoW : msjInfoW,
                        abrirModalInfoW : true
                    });
            }
        });

        
    
    }

    asignarHora = async(hora) => {
        this.setState({idProgramacionSede: hora})
        this.state.listaHoras.map(valor =>{
            if(valor.id.idProgramacionSede === hora){
                this.setState({horaSeleccionada: valor.horaEvento})
            }
        })
    }

    render() {
        
        const ahora = moment();
        const datosAspirante = this.props.datosAspirante || {};
        const datosUsuario = this.props.datosUsuario || {};
        const sede = this.state.sede;
        const listaSedes = this.listaSedes || [];
        const listaFechaHora = this.listaFechaHora || [];
        const views = this.renderViews ? this.renderViews() : {};
        const captura = rolesCaptura.some(rol => (datosUsuario.rolUsuario === rol))
        const aparece = (this.props.operaciones.accion === 'captura' || this.props.operaciones.accion === 'asignaSede') &&
                        captura;
        const permitirTexto = datosAspirante.estatusRegistro === 4 || datosAspirante.estatusRegistro === 5 ? 'Deshacer declinación' : 'Permitir registro';
        const aceptarTexto = this.props.operaciones.accion === 'captura' ? 'Guardar' : 'Asignar sede';
        const activaGuardado = this.props.operaciones.accion === 'asignaSede' || this.state.activaGuardado;
        const sinCede = this.props.form.getFieldValue('sinCede');
        var sinRadio = this.state.todosValidos || !captura;
        const listaFechas = this.listaFechas || [];
        const listaHoras = this.listaHoras || [];

        if(this.props.datosAspirante.estatusRegistro === 4 || this.props.datosAspirante.estatusRegistro === 5)
            sinRadio = false;
        

        const fechaId = this.props.form.getFieldValue('fechaExamenId');
        const listaHora = [];
        if(fechaId !== undefined){
            listaFechaHora.forEach(valor => {
                if(valor.id.idFecha === fechaId){
                    listaHora.push(valor);
                }
            });
        }
        const fecha = this.props.form.getFieldValue('fechaExamen');
        const sinFecha = !fecha && !fechaId;
        var horaMin;
        if (fecha) {
            const ahoraStr = ahora.format(etiquetas.FORMATO_FECHA_MOMENT);
            //const fechaStr = fecha.format(etiquetas.FORMATO_FECHA_MOMENT);
            //horaMin = ahoraStr === fechaStr ? ahora.format('HH:mm') : '08:00';
        }

        const tituloValidacion = datosAspirante.tieneDocumentacion === 'S' ? 
            "Has validado los documentos, asigna sede una vez que el aspirante haya visualizado o acudido a la cápsula de inducción." :
            "Has permitido el registro del aspirante, a continuación adjunta la documentación correspondiente";


        return (
            <AuthenticatedComponent externo={false}
                                    listo={this.listo}>
                                    <Modal
                                      className="modalError"
                                      title={<img  src={errorImgModal} id="img-error-modal"/>}
                                      centered
                                      onCancel={()=>this.cerrarErrorModal()}
                                      visible={this.state.abrirModalError}
                                      footer={false}
                                      width={400}
                                    >
                                      {this.state.msjError}
                                    </Modal>
                <Template contenido={
                    <Layout className='validar_modulo'>
                        <Link to={`/bandeja`} className="btn btn-success mr-2" style={{'marginTop':'15px'}}>
                            <Icon type="arrow-left"/> Regresar
                        </Link>
                        <Header theme='light' className='header_validar'>
                            <div>
                                <div>Documentación por validar</div>
                                <Row>
                                  <Col xs={24} sm={24} md={12} lg={12} xl={12} id="validar_datosAspirante" style={{'textAlign':'left'}}>
                                    <p className="datosAspirante">
                                      <span>Nombre:</span>&nbsp; {datosAspirante.nombre} {datosAspirante.apellidoPaterno} {datosAspirante.apellidoMaterno}
                                    </p>
                                    <p className="datosAspirante">
                                      <span>Clave de elector:</span>&nbsp; {datosAspirante.claveElectorFuar}
                                    </p>
                                  </Col>
                                  <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                    <p></p>
                                    <p className="datosAspirante">
                                      <span>Sección:</span>&nbsp; {datosAspirante.seccionDom}
                                    </p>
                                  </Col>
                                </Row>
                            </div>
                        </Header>
                        <Layout className='contenido_validar' onFocus={this.establecerIniciales}>
                            <Content className='contenido_anidado'>
                                <React.Fragment>
                                    <div className='visor_validar'>
                                        {this.state.cargado ? views.viewers : null}
                                    </div>
                                </React.Fragment>
                            </Content>
                            <Sider theme='light' width='30%'>
                                <div className='encabezado_validar'>
                                    <span onClick={() => this.cambiarTab(0)} className={this.state.tab === 0 ? 'validar_activo' : ''}
                                          style={{'width': '30%'}}>
                                        Obligatoria
                                    </span>
                                    <span onClick={() => this.cambiarTab(1)} className={this.state.tab === 1 ? 'validar_activo' : ''}
                                          style={{'width': '30%'}}>
                                        Opcional
                                    </span>
                                </div>
                                {this.state.cargado ? views.controlls : null}
                                {/*    <hr />
                                        <a href='#' onClick={(e) => this.toggleMostrar(e, 'mostrarCarta')}><Icon type='eye'/> Ver carta declaratoria</a>
                                <hr/>*/}
                                <Cubrimiento cubrir={this.props.operaciones.accion !== 'captura'}>
                                    <RadioGroup nombre='radioDecision'
                                                form={this.props.form}
                                                disabled={sinRadio}
                                                ref={this.radioDecisionRef}>
                                    {datosAspirante.estatusRegistro !== 4 && datosAspirante.estatusRegistro !== 5 ?
                                        <Radio value='true' onClick={(e) => this.manejarRadiosJDE('true', e)}>Acude a la junta</Radio>
                                        : null
                                    }    
                                    <Radio value={'false'} onClick={(e) => this.manejarRadiosJDE('false', e)}>Declinar solicitud</Radio>
                                    {console.log((datosAspirante.estatusRegistro === 4 || datosAspirante.estatusRegistro === 5) ?  true : false)}
                                    {datosAspirante.bAcudirJDE === 1 || datosAspirante.estatusRegistro === 4 || datosAspirante.estatusRegistro === 5 ?
                                        <Radio value='permite' onClick={(e) => this.manejarRadiosJDE('permite', e)}>{permitirTexto}</Radio>
                                        : null
                                    }
                                    </RadioGroup>
                                </Cubrimiento>
                                <Footer>
                                    <Button type='primary' onClick={this.cancelarRevision}>{this.props.operaciones.accion === 'consulta' ? 'Volver' : 'Cancelar'}</Button>
                                    {aparece ? (
                                        <Button type='primary'
                                                style={{marginLeft:'15%'}}
                                                disabled={!activaGuardado}
                                                onClick={this.confirmar}>{aceptarTexto}</Button>
                                        ) : null
                                    }
                                </Footer>
                            </Sider>
                        </Layout>
                    </Layout>
                }
                guia={false}
                bloqueado={!this.props.datosAspirante}
                cargando={this.state.cargando}
                bloquearTodo={this.state.cargando}/>

                <Modal visible={this.state.mostrarConfirmacion}
                       title={null}
                       centered
                       closable={false}
                       onOk={this.validarRevision}
                       onCancel={this.cancelarConfirmacion}
                       disabled={!activaGuardado}
                       footer={null}
                       width={390}>
                    <div className="mensaje_confirmacion">{this.confirmacion}</div>
                        <br/>
                    <div id="modal_botones">
                        <Button className="botonesModal" onClick={this.cancelarConfirmacion}>
                            Cancelar
                        </Button>
                        <Button className="botonesModal" onClick={this.validarRevision}>
                            Aceptar
                        </Button>
                        
                    </div>
                </Modal>
                <Modal visible={this.state.mostrarCarta}
                       title='Carta declaratoria'
                       centered
                       style={{width: '600px'}}
                       onCancel={(e) => this.toggleMostrar(e, 'mostrarCarta')}
                       width={this.state.widthModal}
                       footer={null}>
                    <SourceViewer nombre='cartaDeclararoria'
                                  urlDoc={process.env.REACT_APP_API_URL + '/ws_reclutaseycae_central/ws/carta_declaratoria'}
                                  type='application/pdf'
                                  recursos={{}}
                                  visible={() => true}
                                  onLoad={this.modificaModal}/>
                </Modal>
                <Modal visible={this.state.mostrarPlaticaInducion}
                    centered
                    onOk={null}
                    onCancel={null}
                    closable={false}
                    footer={null}>
                    <div className="mensaje_confirmacion" style={{margin:'5px 25px'}}>
                        <span style={{ fontSize: '18px'}}>{tituloValidacion}</span>
                        <br/>
                    </div>
                    <div id="modal_botones">
                        <Button className="botonesModal" style={{width: 150}} onClick={() => this.guardarRevision(true)}> Aceptar </Button>
                    </div>
                </Modal>
                <Modal visible={this.state.mostrarDeshacerDeclinacion}
                    centered
                    onOk={null}
                    onCancel={null}
                    closable={false}
                    footer={null}>
                    <div className="mensaje_confirmacion" style={{margin:'5px 25px'}}>
                        <span style={{ fontSize: '18px'}}>{'Se va a deshacer la declinación'}<br />{this.state.mostrarMensajeOtroCorte ? 'Al continuar se eliminará la sede previamente asignada debido a que la sección ya no existe en el corte geográfico actual':''}<br />{'¿deseas continuar?'}</span>
                        <br/>
                    </div>
                    <div id="modal_botones">
                        <Button className="botonesModal" style={{width: 150}} onClick={() => this.cancelarDeshacerDeclinacion()}> Cancelar </Button>
                        <Button className="botonesModal" style={{width: 150}} onClick={() => this.guardarRevision(true)}> Aceptar </Button>
                    </div>
                </Modal>

                <Modal visible={this.state.mostrarCuadroExamen && this.state.sedesCargadas}
                       title={"Has validado todos los documentos del ciudadano"}
                       onCancel={(e) => this.toggleMostrar(e, 'mostrarCuadroExamen')}
                       closable={false}
                       okText='Guardar'
                       onOk={() => this.guardarRevision(true)}
                       okButtonProps={{disabled: (this.props.operaciones.accion === 'asignaSede' && listaSedes.length === 0) || ((datosAspirante.otroCorte ===1 || this.state.encuentraOtroCorte) && !sinCede ) ? true: false}}
                       cancelText='Cancelar'
                       zIndex={900}
                       width={700}>
                    {this.props.operaciones.accion === 'captura' ?
                        <Checkbox nombre='sinCede'
                            form={this.props.form}
                            required={false}
                            rules={[{type: 'boolean'}]}
                            onChange={this.cambioAsignarSede}>
                            <b>Asignar sede en otro momento</b>
                        </Checkbox>
                        : null}

                    <b className={sinCede ? 'inactivo' : ''}>Asigna los datos para presentación del examen:</b>

                    {this.state.sedesCargadas && listaSedes.length === 1 && datosAspirante.otroCorte !== 1 ? (
                        <> <p/>
                        <p>
                            <span>Sede:</span><br/>
                            <span>{sede}</span>
                        </p>
                        </>)
                        :
                        <Select nombre='sede'
                                placeholder='Sede'
                                required={!sinCede}
                                form={this.props.form}
                                showSearch={true}
                                disabled={sinCede || (listaSedes.length === 0 ? true : false) || this.state.encuentraOtroCorte}
                                onChange={(value) =>{this.obtenerFechasSedes(value)}}>
                            {listaSedes.map(valor => {
                                return (
                                <Option key={valor.id.idSede + 'Sede'} value={valor.id.idSede} >
                                    {`${valor.lugar} | ${valor.domicilioSede}, Col. ${valor.colonia}, C.P. ${valor.cp}`}
                                </Option>);
                            })}
                        </Select>
                    }

                    <Row type='flex' justify='space-between'>
                        <Col span={11}>
                        <Select nombre='fechaExamen'
                                placeholder='Fecha de examen'
                                required={!sinCede}
                                form={this.props.form}
                                showSearch={true}
                                disabled={sinCede || (this.state.listaFechas.length === 0 ? true : false)}
                                onChange={(value) =>{this.obtenerHorasSedes(value)}}>
                            {this.state.listaFechas.map(valor => {
                                return (
                                <Option key={valor.fechaEvento} value={valor.posicionFecha} >
                                    {valor.fechaEvento.split('T')[0]}
                                </Option>);
                            })}
                        </Select>
                        </Col>
                        <Col span={11}>
                        <Select nombre='horaExamen'
                                placeholder='Hora de examen'
                                required={!sinCede}
                                form={this.props.form}
                                showSearch={true}
                                disabled={sinCede || (this.state.listaHoras.length === 0 ? true : false)}
                                onChange={(value) =>{(this.asignarHora(value))}}
                                >
                            {this.state.listaHoras.map(valor => {
                                return (
                                <Option key={valor.horaEvento} value={valor.id.idProgramacionSede} >
                                    {valor.horaEvento}
                                </Option>);
                            })}
                        </Select>
                        </Col>
                    </Row>
                </Modal>
                <Modal
                    className="modalError"
                    title={<img  src={infow_iconModal} id="img-error-modal"/>}
                    centered
                    onCancel={()=>this.cerrarInfoWModal()}
                    visible={this.state.abrirModalInfoW}
                    footer={false}
                    width={400}>
                    {this.state.msjInfoW}
                </Modal>
            </AuthenticatedComponent>
        );
    }
}

class CuadroValidacion extends Component {
    state = {validado: undefined,
             observacion: undefined,
             clase: 1,
             tab:0}

    componentDidMount() {
        var validar;
        var rechazar;
        var eliminar;

        if (this.props.archivoValido) {
            validar = this.props.archivoValido === 'S';
            rechazar = !validar;
        }

        this.props.cambiarValidacion({
            nombre: this.props.nombre,
            id: this.props.id,
            validado: this.props.archivoValido,
            observacion: this.props.observacion
        });

        this.props.form.setFields({
            [this.props.nombre + 'Validar'] : {value: validar},
            [this.props.nombre + 'Rechazar']: { value: rechazar },
            [this.props.nombre + 'Eliminar']: { value: eliminar },
            [this.props.nombre + 'Observacion'] : {value: this.props.observacion},
        });

        this.setState({validado: this.props.archivoValido});
    }

    handleChange = (nombre, val) => {
        const nombreRechazar = this.props.nombre + 'Rechazar';
        this.props.form.haValidado = false;

        if (val) {
            this.props.form.setFields({ [nombre]: { value: !val } });
            this.props.form.setFields({ [this.props.nombre + 'Eliminar']: { value: false } });
        }

        const validado = val ? (nombre === nombreRechazar ? 'S' : 'N') : undefined;
        this.setState({validado});
        this.props.cambiarValidacion({nombre: this.props.nombre, id: this.props.id, validado, observacion: this.state.observacion});
    }

    handleChangeEliminar = (nombreValidar, nombreRechazar, nombre, val) => {
        const nombreEliminar = this.props.nombre + 'Eliminar';
        this.props.form.haValidado = false;

        if (val) {
            this.props.form.setFields({ [nombre]: { value: val } });
            this.props.form.setFields({ [nombreValidar]: { value: false } });
            this.props.form.setFields({ [nombreRechazar]: { value: false } });
        }

        const validado = val && (nombre === nombreEliminar) ? 'E' : undefined;
        this.setState({ validado });
        this.props.cambiarValidacion({ nombre: this.props.nombre, id: this.props.id, validado, observacion: this.state.observacion });

    }

    handleInputChange = () => {
        const observacion = this.props.form.getFieldValue(this.props.nombre + 'Observacion');
        this.props.cambiarValidacion({nombre: this.props.nombre, id: this.props.id, validado: this.state.validado, observacion});
        this.setState({observacion});
    }

    componentDidUpdate() {
        if (this.state.clase === 2) {
            setTimeout(() => this.setState({clase: 1}), 0);
            this.props.scrollVisor(this.props.nombre);
        }
    }

    getFocus = () => {
        this.props.cambioFoco(this.props.nombre, () => {
            this.setState({clase: 2});
        });
    }

    render() {
        const nombreValidar = this.props.nombre + 'Validar';
        const nombreRechazar = this.props.nombre + 'Rechazar';
        const nombreEliminar = this.props.nombre + 'Eliminar';
        const cN = this.state.clase === 1 ? 'cuadro_validacion' : 'cuadro_validacion cuadro_validacion_tomado';
        const vs = !this.props.visible() ? 'visor_hidden' : '';

        return (
            <div id={'id' + this.props.nombre}
                 className={cN + ' ' + vs}
                 onFocus={this.getFocus}
                 tabIndex={this.props.id}>
                <Cubrimiento>
                    <div className='cuadro_validacion_titulo'>{this.props.titulo}</div>
                    <div>
                        <InputText form={this.props.form}
                                nombre={this.props.nombre + 'Msj'}
                                elementClass='solo_error'/>
                        <Checkbox form={this.props.form}
                                disabled={this.props.cubrir}
                                nombre={nombreValidar}
                                required={false}
                                rules={[{type: 'boolean'}]}
                                onChange={e => {this.handleChange(nombreRechazar, e)}}
                                style={{'color':'#000', 'fontWeight': 'bold'}}>
                            {this.state.validado ? 'Validado' : 'Validar'}
                        </Checkbox>
                        <Checkbox form={this.props.form}
                                disabled={this.props.cubrir}
                                nombre={nombreRechazar}
                                required={false}
                                rules={[{type: 'boolean'}]}
                                onChange={e => {this.handleChange(nombreValidar, e)}}
                                style={{'color':'#000', 'fontWeight': 'bold'}}>
                            {this.state.validado ? 'Rechazado' : 'Rechazar'}
                        </Checkbox>
                        <Checkbox form={this.props.form}
                                disabled={this.props.cubrir}
                                nombre={nombreEliminar}
                                required={false}
                                rules={[{ type: 'boolean' }]}
                                onChange={e => { this.handleChangeEliminar(nombreValidar, nombreRechazar, nombreEliminar, e) }}
                                style={{ 'color': '#000', 'fontWeight': 'bold', 'visibility': this.props.tab === 1 ? 'visible' : 'hidden' }}>
                                Eliminar
                        </Checkbox>
                    </div>
                    <div>
                        <TextArea nombre={this.props.nombre + 'Observacion'}
                                placeholder='Observaciones'
                            form={this.props.form}
                                disabled={(!this.state.validado || this.state.validado === 'S' || this.state.validado === 'E') || this.props.cubrir}
                                maxLength={300}
                                rules={[{
                                    pattern: etiquetas.REGEX_FORMATO_NO_CARACTERES_ESPECIALES
                                }]}
                                required={this.state.validado === 'N'}
                                onBlur={this.handleInputChange}
                                autosize={{minRows: 5, maxRows: 5}}
                        />
                    </div>
                </Cubrimiento>
            </div>
        );
    }
}

const mapStateToProps = createStructuredSelector({
    proceso: selectProceso,
    datosAspirante: selectAspirante,
    datosUsuario: selectCurrentUser,
    operaciones: selectOperaciones

});


export default Form.create({name: 'validacion', onFieldsChange: function onValuesChange() {
    _compararValores();
}})(connect(mapStateToProps, {implantarAspirante, emitirOperacion, borrarOperacion})(ValidacionDocumentos));
